import { Grid } from '@mui/material';
import UserRole from '../../../shared/AuthRoles';
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import ProfileSummary from '../../components/Profile/ProfileSummary';
import ProfileForm from '../../components/Profile/Form/ProfileForm';
import {
    PROFILE_SETUP_HIGHLIGHT_STATE_KEY,
    type ProfileSetupLocationState,
} from '../../components/Profile/profileSetupBanner';
import { useGetIndividualContractorQuery } from '../../../app/Slices/SevenDayApiSlice';
import LoadingComponent from '../../../layout/styledcomponents/LoadingAnimations/LoadingComponent';

export default function ProfilePage({
    contractorCompany,
}: {
    contractorCompany: boolean;
}) {
    const loggedInUser = UserRole();
    const location = useLocation();

    const { data: profile } = useGetIndividualContractorQuery(
        loggedInUser?.company,
        { skip: !contractorCompany },
    );

    const setupComplete = !!profile?.abn;

    const [highlightProfileSetup, setHighlightProfileSetup] = useState(() => {
        const state = location.state as ProfileSetupLocationState | null;
        return Boolean(state?.[PROFILE_SETUP_HIGHLIGHT_STATE_KEY]);
    });

    useEffect(() => {
        const state = location.state as ProfileSetupLocationState | null;
        if (state?.[PROFILE_SETUP_HIGHLIGHT_STATE_KEY]) {
            setHighlightProfileSetup(true);
        }
    }, [location.state]);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return contractorCompany && !profile ? (
        <LoadingComponent />
    ) : (
        <Grid
            sx={{
                width: '100%',
                maxWidth: '100%',
                justifyContent: 'left',
                alignItems: 'stretch',
                pb: { xs: 4, sm: 6 },
            }}
        >
            <ProfileForm
                contractorCompany={contractorCompany}
                modernProfileView={!contractorCompany || setupComplete}
                isEditing={contractorCompany && !setupComplete}
                integratedProfileHeader
                highlightProfileSetup={highlightProfileSetup}
                onProfileSetupComplete={() => setHighlightProfileSetup(false)}
                profileSummarySlot={
                    !loggedInUser?.role?.includes('company') &&
                    loggedInUser?.role !== 'admin' &&
                    !contractorCompany ? (
                        <ProfileSummary
                            contractorCompany={contractorCompany}
                            highlightMissingRequired={highlightProfileSetup}
                        />
                    ) : undefined
                }
            />
        </Grid>
    );
}
